import React, { useEffect, useState } from 'react';
import { ReactComponent as LogoIcon } from '../../assets/Logo.svg';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { css } from '@emotion/react';
import { ThemeProvider, Grid, IconButton, Box, Typography } from '@mui/material';
import theme from './theme';
import AppProvider, { useAppContext } from 'contexts/AppContext';
import InsurcanceCarProvider from './context';
import { useThemeContext } from 'contexts/ThemeContext';
import { makeStyles } from '@mui/styles';
import Snackbar from 'components/Snackbar';
import HomeIcon from '@mui/icons-material/Home';
import NotiButton from './NotiButton';

const headerStyle = () => css`
  z-index: 1;
  position: relative;
  background-size: 100%;
  top: 0;
  padding: 0 10px 0 10px;
  background-color: transparent;
  font-weight: 700;

  & > nav {
    height: 100%;
    display: flex;
    margin: 0px 0px;
    max-width: 480px;
    align-items: center;
    justify-content: flex-start;
    .boxLeft {
      width: 20%;
      display: flex;
      margin-left: 0px;
      justify-content: flex-start;
    }
    .boxRight {
      width: 80%;
      display: flex;
      margin: 0px;
      align-items: center;
      justify-content: flex-end;
    }

    .logo1 a {
      height: 100%;
      display: flex;
      align-items: flex-start;
      margin-left: 0px !important;

      svg {
        width: 100%;
        height: 32px;
      }
    }
  }
`;
const useStyles = makeStyles((theme) => ({
  headerBgCus: ({ color }) => {
    return {
      maxWidth: '480px',
      width: '100%',
      position: 'fixed',
      top: 0,
      backgroundColor: color,
      height: '60%',
      WebkitMaskImage:
        '-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))',
      maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
    };
  },
}));

const HomeButton = (props) => {
  const history = useHistory();
  const { getUserInfo } = useAppContext();
  const [showHomeButton, setShowHomeButton] = useState(false);

  useEffect(() => {
    const user = getUserInfo();
    if (
      user &&
      (user.roles.includes('SALE_CTPL') ||
        user.roles.includes('SALE_AUTOCARE') ||
        user.roles.includes('SALE_PRODUCT_CTPL_4WHEEL'))
    ) {
      setShowHomeButton(true);
    }
  }, []);

  return showHomeButton ? (
    <Box>
      <IconButton
        onClick={() => {
          // const user = getUserInfo();
          // if (user && (user.roles.includes('DIGIIN_SELLER'))) {
          //   history.push('/sale');
          // } else {
          //   history.push('/');
          // }
          history.push('/sale');
        }}
      >
        <HomeIcon color="textColor" />
      </IconButton>
    </Box>
  ) : null;
};

const AppLayout = ({ children }) => {
  const { mainColor, textColor } = useThemeContext();
  const classes = useStyles({ color: mainColor });
  const location = useLocation();

  const getRouteName = (pathName) => {
    const mainPathName = pathName.split('/')[1];
    if (pathName.split('/').length > 2 && pathName.split('/')[2] === 'payment-result') return null;
    switch (mainPathName) {
      case 'insurance-car':
        return 'Bảo hiểm vật chất xe ô tô';
      default:
        return null;
    }
  };

  return (
    <ThemeProvider theme={theme({ mainColor, textColor })}>
      <AppProvider>
        <InsurcanceCarProvider>
          <div className={classes.headerBgCus} style={{ top: '0px' }}></div>
          <header css={[headerStyle()]}>
            {getRouteName(location.pathname) ? (
              <nav>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 0,
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      my: 0,
                      py: '8px',
                    }}
                  >
                    <Typography variant="headerLinkName">
                      {getRouteName(location.pathname)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mt: 1,
                      mb: 1,
                    }}
                  >
                    <NotiButton />
                    <HomeButton />
                  </Box>
                </Box>
              </nav>
            ) : (
              <nav style={{ width: '100%' }}>
                <div className={'boxLeft'}>
                  <div className="logo1">
                    <Link to="/" replace={location.pathname === '/'}>
                      <LogoIcon fill={textColor} />
                    </Link>
                  </div>
                </div>
              </nav>
            )}
          </header>
          <Snackbar />
          <div style={{ position: 'relative' }}>
            <main>
              <Grid container spacing={1} className={'content'} style={{ height: '90vh' }}>
                <Grid item xs={12} sm={12} md={12}>
                  {children}
                </Grid>
              </Grid>
            </main>
          </div>
        </InsurcanceCarProvider>
      </AppProvider>
    </ThemeProvider>
  );
};

export default AppLayout;
